/*
 * @Date: 2020-05-19 13:53:54
 * @LastEditors: zhuqiu
 * @LastEditTime: 2020-06-16 16:08:38
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\Tabs\schema.ts
 */
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "tabs",
    type: DataType.Object,
    properties: {
        heads: {
            type: DataType.Array,
            title: i18n.t('dataitem.Options').toString(),
        },
        tabDefaultValue: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultOptions').toString(),
            default: "",
        },
    },
};
